<template>
  <div>
    <div v-if="firebaseError" class="firebase-error-page">
      <div class="error-container">
        <div class="error-icon">&#128295;</div>
        <h1>Service temporairement indisponible</h1>
        <p>Une erreur de configuration empêche le chargement de l'application.</p>
        <p class="error-detail">{{ firebaseError.message }}</p>
        <button @click="reload" class="retry-button">Réessayer</button>
      </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import { firebaseError } from '@/firebase'

export default {
  name: 'App',
  data() {
    return {
      firebaseError
    }
  },
  methods: {
    reload() {
      window.location.reload()
    }
  }
}
</script>

<style>
body {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1A1A1A;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: #000000;
}

.firebase-error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.error-container {
  background: white;
  padding: 3rem;
  border-radius: 12px;
  text-align: center;
  max-width: 400px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.error-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.error-container h1 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.error-container p {
  color: #666;
  margin-bottom: 0.5rem;
}

.error-detail {
  font-size: 0.85rem;
  color: #999;
  font-family: monospace;
  background: #f5f5f5;
  padding: 0.5rem;
  border-radius: 4px;
  margin: 1rem 0;
}

.retry-button {
  background: #667eea;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 1rem;
  transition: background 0.2s;
}

.retry-button:hover {
  background: #5a6fd6;
}
</style>
